<template>
    <header class="app-header">
        <nav class="navbar navbar-light container-fluid px-0 jusity-content-between"
            :class="user ? '' : 'jusity-content-start'">
            <ul class="navbar-nav d-block d-xl-none" v-if="user">
                <li class="nav-item">
                    <a class="nav-link sidebartoggler ms-n3" @click="$emit('sidebartoggler')" href="javascript:void(0)">
                        <i class="ti ti-menu-2"></i>
                    </a>
                </li>
            </ul>
            <div>
                <router-link :to="{ name: 'Home' }" class="text-nowrap nav-link d-lg-block d-none">
                    <img :src="app ? app.icon : icon" height="50" />
                </router-link>
                <router-link :to="{ name: 'Home' }" class="text-nowrap nav-link d-lg-none">
                    <img :src="app ? app.icon : icon" height="30" />
                </router-link>
            </div>
            <div v-if="!user && $route.name != 'Login'">
                <router-link :to="{ name: 'Login' }"
                    class="btn btn-primary fs-3 rounded btn-hover-shadow px-3 py-2">Login</router-link>
            </div>
            <div v-if="user">
                <div class="nav-item dropdown">
                    <a class="nav-link pe-0" href="javascript:void(0)" id="drop1" data-bs-toggle="dropdown"
                        aria-expanded="false">
                        <div class="d-flex align-items-center">
                            <div class="user-profile-img">
                                <img :src="profile" class="rounded-circle" width="35"
                                    height="35" alt="" />
                            </div>
                        </div>
                    </a>
                    <div class="dropdown-menu content-dd dropdown-menu-end dropdown-menu-animate-up"
                        aria-labelledby="drop1">
                        <div class="profile-dropdown position-relative">
                            <div class="py-3 px-7 pb-0">
                                <h5 class="mb-0 fs-5 fw-semibold">User Profile</h5>
                            </div>
                            <div class="d-flex align-items-center py-9 mx-7">
                                <div class="ms-3">
                                    <h5 class="mb-1 fs-3">{{ user.first_name }} {{ user.last_name }}</h5>
                                    <p class="mb-0 d-flex text-dark align-items-center gap-2">
                                        <i class="ti ti-mail fs-4"></i> {{ user.email }}
                                    </p>
                                </div>
                            </div>
                            <div class="d-grid py-4 px-7 pt-8">
                                <a href="javascript:void(0)" @click="onLogout()" class="btn btn-outline-primary">Cerrar
                                    sesión</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </nav>
    </header>
</template>
<script>
import icon from '@/assets/logo.png'
import profile from '@/assets/images/profile/user-1.jpg'
export default {
  props: {
    user: {
      type: Object,
      default: () => ({})
    },
    app: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      icon,
      profile
    }
  },
  methods: {
    onLogout: function () {
      this.$store.dispatch('LOGOUT')
      this.$router.push({ name: 'Login' })
      try {
        this.$axios({
          url: '/logout',
          method: 'GET'
        })
      } catch (error) { }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/layout/partials/AppHeader.vue